export enum PointsRange {
    First = 'First',
    Second = 'Second',
    Third = 'Third',
    Fourth = 'Fourth',
}
